import axios, { AxiosError, type InternalAxiosRequestConfig } from "axios";
import keycloak from "../keycloak.js";
// import axiosJsonp from "axios-jsonp-pro";


const api = axios.create({
    baseURL: import.meta.env.VITE_CAD_API_URL,
    timeout: 10000
});

export const apiCnpj = axios.create({
    baseURL: import.meta.env.VITE_CAD_CNPJ_API_URL,
    timeout: 10000
});

export const apiCep = axios.create({
    baseURL: import.meta.env.VITE_CAD_CEP_API_URL,
    timeout: 10000
});

export const apiLocalidades = axios.create({
    baseURL: import.meta.env.VITE_CAD_LOCALIDADES_API_URL,
    timeout: 10000
});

export const apiEntidade = axios.create({
    baseURL: import.meta.env.VITE_CAD_EFPC_API_URL,
    timeout: 10000
});

export const apiPlanosBeneficios = axios.create({
    baseURL: import.meta.env.VITE_CAD_PLANO_API_URL,
    timeout: 10000
});

export const apiConvenio = axios.create({
    baseURL: import.meta.env.VITE_CAD_CONVENIO_API_URL,
    timeout: 10000
});

export const apiPrimarias = axios.create({
    baseURL: import.meta.env.VITE_CAD_PRIMARIAS_API_URL,
    timeout: 10000
});

export const apiCtrlDoc = axios.create({
    baseURL: import.meta.env.VITE_CAD_CTRLDOC_API_URL,
    timeout: 10000
});

export const apiDocumentos = axios.create({
    baseURL: import.meta.env.VITE_APP_URL_API_DOCUMENTOS,
    timeout: 10000
});

export const apiVerDocumentos = axios.create({
    baseURL: import.meta.env.VITE_APP_URL_API_DOCUMENTOS,
    timeout: 10000
});

export const apiEstados = axios.create({
    baseURL: import.meta.env.VITE_APP_URL_API_ESTADOS,
    timeout: 10000
});

const defaultRequestInterceptor = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    const token = keycloak.token;
    if (config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
};

api.interceptors.request.use(defaultRequestInterceptor, (error: AxiosError) => {
    // Handle request error
    return Promise.reject(error);
});

apiCnpj.interceptors.request.use(defaultRequestInterceptor, (error: AxiosError) => {
    // Handle request error
    return Promise.reject(error);
});

apiCep.interceptors.request.use(defaultRequestInterceptor, (error: AxiosError) => {
    // Handle request error
    return Promise.reject(error);
});

apiLocalidades.interceptors.request.use(defaultRequestInterceptor, (error: AxiosError) => {
    // Handle request error
    return Promise.reject(error);
});

apiEntidade.interceptors.request.use(defaultRequestInterceptor, (error: AxiosError) => {
    // Handle request error
    return Promise.reject(error);
});

apiPlanosBeneficios.interceptors.request.use(defaultRequestInterceptor, (error: AxiosError) => {
    // Handle request error
    return Promise.reject(error);
});

apiConvenio.interceptors.request.use(defaultRequestInterceptor, (error: AxiosError) => {
    // Handle request error
    return Promise.reject(error);
});

apiPrimarias.interceptors.request.use(defaultRequestInterceptor, (error: AxiosError) => {
    // Handle request error
    return Promise.reject(error);
});

apiCtrlDoc.interceptors.request.use(defaultRequestInterceptor, (error: AxiosError) => {
    // Handle request error
    return Promise.reject(error);
});

apiDocumentos.interceptors.request.use(defaultRequestInterceptor, (error: AxiosError) => {
    // Handle request error
    return Promise.reject(error);
});

apiEstados.interceptors.request.use(defaultRequestInterceptor, (error: AxiosError) => {
    // Handle request error
    return Promise.reject(error);
});




//***************************** */      

// export const apiEntidade = axios.create({
//     baseURL: import.meta.env.REACT_APP_CAD_EFPC_API_URL,
// });

export const apiGateway = axios.create({
    baseURL: import.meta.env.REACT_APP_CAD_GATEWAY_API_URL,
});

// export const apiLocalidades = axios.create({
//     baseURL: import.meta.env.VITE_CAD_CNPJ_API_URL,
// });

export const apiCnae = axios.create({
    baseURL: import.meta.env.REACT_APP_CNAE_API_URL,
});

export interface IErroApi {
    datahora: string;
    status: number;
    error: string;
    mensagem: string;
    path: string;
    details: Detail[]
    campos: Campos[];
}

export interface Detail {
    defaultMessage: string
    errors: string[]
}

export interface Campos {
    cmensagem: string;
    cnome: string;
}

export default api;